import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVolumeMaxComponent } from "./med-icon-volume-max.component";

@NgModule({
  declarations: [
    MedIconVolumeMaxComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVolumeMaxComponent,
  ],
})
export class MedIconVolumeMaxModule { }
